import { LumaClientType } from "@luma-team/shared";
import { addGlowIdDict } from "@glow/react/components/glow-id/GlowIdProvider";
import config from "../config";
import { GlowClientConstructor } from "@glow/react/utils/GlowClientConstructor";

export const ZmClient = new GlowClientConstructor(config.apiUrl, {
  clientType: LumaClientType.GlowWeb,
  onResponse: (resp) => {
    addGlowIdDict(resp as any);
  },
});
